import { hooks } from '@wove/react';
import { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { bodyAppendDivElement, BodyAppendDivElementProps, removeBodyChild } from '../utils';
import { ImageViewerInner, ImageViewerProps } from './image-viewer';

export type TDialogImageViewerProps = Pick<ImageViewerProps, 'images' | 'initActiveIndex'>;

const ModalRender = (props: TDialogImageViewerProps & BodyAppendDivElementProps) => {
  const [visible, setVisible] = useState(false);

  const onClose = () => {
    setVisible(false);
  };

  useEffect(() => {
    setVisible(true);
  }, []);

  const onAfterClose = hooks.useCallbackRef(() => {
    removeBodyChild(`#${props.elementId}`);
  });

  return (
    <ImageViewerInner
      {...props}
      visible={visible}
      onClose={onClose}
      onAfterClose={onAfterClose}
      destroyOnClose={true}
    />
  );
};

export const dialogImageViewer = (props: TDialogImageViewerProps) => {
  const { divElement, elementId } = bodyAppendDivElement();
  ReactDOM.render(<ModalRender {...props} divElement={divElement} elementId={elementId} />, divElement);
};
